/**
 * Determines if a hex color is light or dark based on its luminance
 * @param hexColor - The hex color string (with or without # prefix)
 * @returns boolean - true if the color is light, false if dark
 */
export const isLightColor = (hexColor: string): boolean => {
  // Remove the # if present
  const color = hexColor.replace('#', '');

  // Convert hex to RGB
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return true if the color is light
  return luminance > 0.5;
};
